// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Domainler',
  subtitle: 'Tüm domain kayıtlarını yönetin',
  addNew: 'Yeni Domain',
  edit: 'Düzenle',
  delete: 'Sil',
  searchPlaceholder: 'Domain, müşteri veya registrar ara...',
  filterAll: 'Tümü',
  filterActive: 'Aktif',
  filterInactive: 'Pasif',
  resultsFound: 'domain bulundu',
  noDomains: 'Henüz domain yok',
  noDomainsFiltered: 'Arama sonucu bulunamadı',
  noDomainsDesc: 'Farklı arama terimleri deneyin',
  noDomainsStart: 'İlk domaininizi ekleyerek başlayın.',
  tableDomain: 'Domain',
  tableCompany: 'Şirket',
  tableRegistrar: 'Registrar',
  tableServer: 'Sunucu',
  tableStatus: 'Durum',
  tableExpiry: 'Bitiş',
  tableNs: 'NS',
  tableMonitoring: 'Monitoring',
  tableActions: 'İşlemler',
  statusActive: 'Aktif',
  statusInactive: 'Pasif',
  statusOnline: 'Online',
  statusOffline: 'Offline',
  domainOwnerOurs: 'Bizde',
  domainOwnerCustomer: 'Kendisinde',
  expired: 'Süresi dolmuş',
  expiredDaysAgo: 'gün önce',
  todayLastDay: 'Bugün son gün',
  daysLeft: 'gün kaldı',
  lastCheck: 'Son kontrol',
  monitoringActive: 'Website monitoring aktif',
  monitoringPassive: 'Website monitoring pasif',
  viewDetails: 'Detayları Görüntüle',
  deleteConfirm: 'Bu domaini silmek istediğinizden emin misiniz?',
  domainAdded: 'Domain başarıyla eklendi',
  domainUpdated: 'Domain başarıyla güncellendi',
  domainDeleted: 'Domain başarıyla silindi',
  fetchError: 'Veriler alınamadı',
  addError: 'Domain eklenemedi',
  updateError: 'Domain güncellenemedi',
  deleteError: 'Domain silinemedi',
  monitoringToggleError: 'Website monitoring durumu güncellenemedi',
  whoisTitle: 'WHOIS\'ten Gelen Veriler',
  whoisRegistrationDate: 'Kayıt Tarihi',
  whoisExpiryDate: 'Bitiş Tarihi',
  whoisStatus: 'Durum',
  whoisNs1: 'NS1',
  whoisNs2: 'NS2',
  whoisRegistrar: 'Registrar',
  whoisClose: 'Kapat',
  whoisEnterDomain: 'Lütfen önce domain adını girin',
  whoisQuerying: 'WHOIS bilgileri sorgulanıyor...',
  whoisSuccess: 'WHOIS bilgileri başarıyla alındı',
  whoisParseError: 'WHOIS verileri parse edilemedi.',
  whoisFetchError: 'WHOIS bilgileri alınamadı',
  domainList: 'Domain Listesi',
  tabAll: 'Tümü',
  tabByCustomer: 'Müşteriye Göre',
  tabByCompany: 'Şirkete Göre',
  formTitle: 'Yeni Domain Ekle',
  formEditTitle: 'Domain Düzenle',
  domainName: 'Domain Adı',
  domainNamePlaceholder: 'example.com',
  company: 'Şirket',
  selectCompany: 'Şirket Seçin',
  companyLoading: 'Yükleniyor...',
  companyNotFound: 'Şirket bulunamadı',
  registrar: 'Registrar',
  selectRegistrar: 'Registrar Seçin',
  server: 'Sunucu',
  selectServer: 'Sunucu Seçin',
  status: 'Durum',
  domainOwner: 'Domain Sahibi',
  registrationDate: 'Kayıt Tarihi',
  expiryDate: 'Bitiş Tarihi',
  formRegistrar: 'Registrar',
  whoisRegistrarPlaceholder: 'WHOIS\'ten otomatik doldurulur',
  ns1: 'NS1',
  ns1Placeholder: 'ns1.example.com',
  ns2: 'NS2',
  ns2Placeholder: 'ns2.example.com',
  notes: 'Notlar',
  notesPlaceholder: 'Ek notlar...',
  cancelButton: 'İptal',
  addButton: 'Ekle',
  updateButton: 'Güncelle',
  exportButton: 'Dışa Aktar',
  exportSuccess: 'Domainler başarıyla dışa aktarıldı',
  unassignedCustomer: 'Atanmamış Müşteri',
  unassignedCompany: 'Atanmamış Şirket',
  domains: 'domain',
  updating: 'Güncelleniyor',
  bulkWhoisUpdate: 'Toplu WHOIS Güncelleme',
  domainsUpdated: '{{current}}/{{total}} domain güncellendi',
  bulkUpdateNoDomains: 'Güncellenecek domain yok',
  bulkUpdateSkippedDomains: 'domain atlandı (.at domainleri)',
  bulkUpdateSkippedInactive: 'pasif domain atlandı',
  bulkUpdateSuccess: 'domain başarıyla güncellendi',
  bulkUpdateSkipped: 'domain atlandı',
  bulkUpdateError: 'Toplu güncelleme hatası',
  noSearchResults: 'Arama sonucu bulunamadı',
  tryDifferentSearch: 'Farklı bir arama terimi deneyin',
  addFirstDomain: 'İlk domaininizi ekleyerek başlayın',
  whoisButton: 'WHOIS',
  activate: 'Aktifleştir',
  deactivate: 'Pasife Al',
  domainActivated: 'Domain aktifleştirildi',
  domainDeactivated: 'Domain pasife alındı',
  statusToggleError: 'Domain durumu güncellenemedi',
  deactivateConfirmTitle: 'Domaini Pasife Al',
  deactivateConfirmMessage: 'Bu domaini pasife almak istediğinizden emin misiniz?',
  deactivateAlsoRelated: 'İlişkili domainleri de pasife al',
  deactivateOnlyThis: 'Sadece bu domaini pasife al',
  relatedDomainsDeactivated: 'İlişkili {{count}} domain de pasife alındı',
  noRelatedDomains: 'İlişkili domain bulunamadı'
};
